// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","277":"34b62b2e","296":"dddfd4fc","732":"a38800b4","977":"49234da2"}[chunkId] + ".chunk.js";
};